import { ComponentProps } from 'react';
import { useGetLocalizedMedia } from '@/shared/lib/hooks/useGetLocalizedMedia';
import { LocalizedMedia } from '@/shared/model/Language';
import { Layout } from '@/shared/ui/layout';
import { Media } from '@/shared/ui/media/types';
import { MiniBanner } from './mini-banner';
import { MiniBannersCarousel } from './mini-banners-carousel';
import { MiniBannersContextProvider } from './mini-banners-context';
import { MiniBannersGrid } from './mini-banners-grid';
import { MiniBannerVariant } from './types';

const PLACEHOLDER_MINI_BANNER: Media = { url: '/images/placeholder-banner-mini.png', alt: '' };
const PLACEHOLDER_MINI_BANNERS = Array.from({ length: 3 }, () => PLACEHOLDER_MINI_BANNER);

type MinibannersProps = ComponentProps<typeof Layout> & {
    data: LocalizedMedia[] | Media[];
    maxColumns?: number;
} & (
        | {
              variant?: `${MiniBannerVariant.GRID}`;
          }
        | {
              variant?: `${MiniBannerVariant.CAROUSEL}`;
          }
    );

export const MiniBanners = ({ variant = 'carousel', data, maxColumns, ...props }: MinibannersProps) => {
    const Wrapper = variant === 'grid' ? MiniBannersGrid : MiniBannersCarousel;
    const getLocalizedMedia = useGetLocalizedMedia();
    const localizedMedia = getLocalizedMedia(data);

    return (
        <Layout {...props}>
            <MiniBannersContextProvider variant={variant}>
                <Wrapper
                    style={{ '--max-columns': maxColumns }}
                    data-testid="mini-banners"
                    data-variant={variant}
                    data-max-columns={maxColumns}
                >
                    {(localizedMedia.length ? localizedMedia : PLACEHOLDER_MINI_BANNERS).map(
                        (media, index) => (
                            <MiniBanner key={index} index={index} data={media} />
                        ),
                    )}
                </Wrapper>
            </MiniBannersContextProvider>
        </Layout>
    );
};
